import React, { memo } from "react";
import { useStaticQuery, graphql } from "gatsby";
import T from "i18n-react";
import { useL } from "@hooks/useDico";
import clsx from "clsx";

import { NavColumnHeader, NavFeatured, NavMiniFeatured, NavItem } from "@components/Nav/Drawers/NavComponents";

const NavDrawerAgencies = memo(function NavDrawerAgencies({ isActive = false }) {
	const data = useStaticQuery(graphql`
		query {
			launchPDOOHCampaign: file(relativePath: { eq: "nav/launch_pdooh_campaign.jpg" }) {
				childImageSharp {
					gatsbyImageData
				}
			}
			doohx: file(relativePath: { eq: "nav/featured_doohx.png" }) {
				childImageSharp {
					gatsbyImageData(width: 75)
				}
			}
			caseStudies: file(relativePath: { eq: "nav/featured_case_studies.png" }) {
				childImageSharp {
					gatsbyImageData(width: 75)
				}
			}
		}
	`);

	const l = useL();

	return (
		<div className={clsx("main_nav__drawer drawer_agencies grid justify-content-between mt-0", { active: isActive })}>
			<div className="col-4 pt-8 pr-0 pl-7 pb-5">
				<NavColumnHeader className="px-5">{T.translate("nav.getStarted")}</NavColumnHeader>
				<NavFeatured
					className="bg-white p-5 rounded-8 hover:bg-zircon"
					thumbnail={data.launchPDOOHCampaign.childImageSharp.gatsbyImageData}
					title={T.translate("nav.launchPDOOHCampaign")}
					description={T.translate("nav.launchPDOOHCampaignDescription")}
					to="launchPDOOHCampaign"
				/>
			</div>
			<div className="col-4 px-10 py-8">
				<NavColumnHeader>{T.translate("nav.executionChannels")}</NavColumnHeader>
				<NavItem id="inventoryMarketplace" />
				<NavItem id="dspPartners" />
				<NavItem id="broadsignAds" />
			</div>
			<div className="col-4 bg-zircon">
				<div className="px-5 pt-6 pb-8 h-full">
					<NavColumnHeader className="px-5">{T.translate("nav.learn")}</NavColumnHeader>
					<NavMiniFeatured
						className=""
						thumbnail={data.doohx.childImageSharp.gatsbyImageData}
						title={T.translate("nav.doohx")}
						to="https://www.doohx.io/"
						cta={T.translate("nav.doohxCTA")}
					/>
					{["en"].includes(l) && (
						<NavMiniFeatured
							className=""
							thumbnail={data.caseStudies.childImageSharp.gatsbyImageData}
							title={T.translate("nav.caseStudies")}
							to="streamCaseStudiesCustomerSpotlights"
							cta={T.translate("nav.caseStudiesCTA")}
						/>
					)}
				</div>
			</div>
		</div>
	);
});

export default NavDrawerAgencies;
